import { User } from 'ha/services/apiV2/types/User';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

const facebookLogin = (makeCall: MakeCall) => (code: string) =>
  makeCall<User>('POST', `${APIV2_URL}/action/facebook-login`, {
    data: { code },
  });

export default facebookLogin;
